import React, { useContext, useEffect } from 'react';
import LoadingIndicator from 'components/LoadingIndicator';
import {
	Wrapper,
	TextContainer,
	NoteContainer,
	SubNoteContainer,
} from './Processing.styles';
import { GenerateSpendCubeContext } from 'contexts/GenerateSpendCubeContext';
import { useToastMessageContext } from 'contexts/ToastMessageContext/ToastMessageProvider';
import { NotificationTypes } from 'components/Toast/constants';
import { ETL_PROCESS_STATUS } from 'Data/constants';

const Processing = ({ message, text }) => {
	const { currentState, fileUplaodErrorPage } = useContext(
		GenerateSpendCubeContext
	);
	const { showToast } = useToastMessageContext();

	useEffect(() => {
		const handleMouseOut = event => {
			const { clientY, clientX } = event;
			if (
				currentState === ETL_PROCESS_STATUS.DATA_UPLOADING &&
				!fileUplaodErrorPage
			) {
				if (
					clientY <= 0 ||
					clientX <= 0 ||
					clientX >= window.innerWidth ||
					clientY >= window.innerHeight
				) {
					showToast(
						'Please stay on the application until all files are uploaded.',
						NotificationTypes.success,
						3000
					);
				}
			}
		};

		document.addEventListener('mouseout', handleMouseOut);
		return () => {
			document.removeEventListener('mouseout', handleMouseOut);
		}; //eslint-disable-next-line
	}, []);

	return (
		<Wrapper>
			<LoadingIndicator loading={true} />
			<TextContainer>
				<NoteContainer>{message}</NoteContainer>
				<SubNoteContainer>{text}</SubNoteContainer>
			</TextContainer>
		</Wrapper>
	);
};

export default Processing;
